import { RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

function configureRoutes() {
  const routes = inject(RoutesService);
  routes.add([
      {
        path: '/',
        name: '::Menu:Home',
        iconClass: 'bi bi-house-door-fill',
        order: 1,
        layout: eLayoutType.application,
      },
      {
        path: '/synchronization',
        name: '::Menu:Synchronization',
        iconClass: 'bi bi-arrow-repeat',
        order: 1,
        layout: eLayoutType.application,
      },
      {
        path: '/dashboard',
        name: '::Menu:Dashboard',
        iconClass: 'bi bi-graph-up-arrow',
        order: 2,
        layout: eLayoutType.application,
        requiredPolicy: 'SeedlingSupplyReception.Dashboard.Host  || SeedlingSupplyReception.Dashboard.Tenant',
      },
  ]);
}
